import Vue from "@/main";
import { set } from "lodash";

export let graphicLayer; // 矢量图层对象
export let positions = []; // 矢量图层对象
let stopDrawShow = false;
let record_lng;

export function createdGraphicLayer() {
  graphicLayer = new mars3d.layer.GraphicLayer();
  Vue.$GLOBAL.map.addLayer(graphicLayer);

  graphicLayer.on(mars3d.EventType.rightClick, function(e) {
    console.log("绘制矢量对象完成", e);
    graphicLayer.stopDraw();
  });

  bindLayerContextMenu();
}
let index = 1;
let rPColor = "#ffd700";
let iurl = "/img/marker/mark" + rPColor.slice(1) + ".png";

// 开始绘制
export function startDrawGraphic(num) {
  graphicLayer.startDraw({
    type: "billboard",
    // type: "billboardP",
    style: {
      image: iurl,
      scaleByDistance_farValue: 0.2,
      scaleByDistance_far: 100000,
      scaleByDistance_near: 100,
      scaleByDistance_nearValue: 0.5,
      // color: "#ff0000",
      scale: 0.5,
      // pixelSize: 6,
      outline: true,
      outlineColor: "#ffffff",
      outlineWidth: 2,
      visibleDepth: false,
      // label: {
      //   // 不需要文字时，去掉label配置即可
      //   text: index,
      //   font_size: 20,
      //   color: "#ffffff",
      //   outline: true,
      //   outlineColor: "#000000",
      //   pixelOffsetY: -20,
      // },
      // image: iurl,
      // scale: 0.5,
      // outline: true,
      // outlineColor: "#000000",
      // outlineWidth: 2,
      // horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      // verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      // visibleDepth: false,
      // label: {
      //   text: index,
      //   font_size: 20,
      //   font_family: "楷体",
      //   color: "#ffff00",
      //   pixelOffsetY: -35,
      //   distanceDisplayCondition: true,
      //   distanceDisplayCondition_far: 500000,
      //   distanceDisplayCondition_near: 0,
      // },
    },
    success: function(graphic) {
      // console.log("绘制矢量对象完成", graphic);

      // position.push([_lng, _lat, _alt]);
      index += 1;
      let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
        graphic._position_draw
      );
      record_lng = _lng;
      positions.push([_lng, _lat, _alt]);

      setTimeout(() => {
        startDrawGraphic(num);
        if (!stopDrawShow) {
          addPoint(num, _alt);
        } else {
          graphicLayer.removeGraphic(graphic);
          graphicLayer.stopDraw();
        }
      }, 500);
    },
  });
}
export function addPoint(num, _alt) {
  if (num <= 0) return;
  for (let i = 0; i < positions.length; i++) {
    if (positions[i + 1]) {
      index -= 1;
      var from = turf.point(positions[i]);
      var to = turf.point(positions[i + 1]);
      var options = { units: "miles" };
      var totalLength = turf.distance(from, to, options).toFixed(3) * 1000; //两点总长 米

      var bearing = turf.rhumbBearing(from, to); //两点角度

      if (totalLength >= num * 2) {
        var destination = turf.rhumbDestination(
          from,
          num / 1000,
          bearing,
          options
        );
        positions.splice(i + 1, 0, [
          destination.geometry.coordinates[0],
          destination.geometry.coordinates[1],
          _alt,
        ]);
        const graphic = new mars3d.graphic.PointEntity({
          name: "根据视距显示点",
          position: [
            destination.geometry.coordinates[0],
            destination.geometry.coordinates[1],
            _alt,
          ],
          style: {
            color: "#ff0000",
            pixelSize: 8,
            outline: true,
            outlineColor: "#ffffff",
            outlineWidth: 1,
            visibleDepth: false,
            // label: {
            //   // 不需要文字时，去掉label配置即可
            //   text: index,
            //   font_size: 20,
            //   color: "#ffffff",
            //   outline: true,
            //   outlineColor: "#000000",
            //   pixelOffsetY: -20,
            // },
          },
        });
        // index += 2;
        graphicLayer.addGraphic(graphic);
      }
    }
  }
  let i = 1;

  // setTimeout((res) => {
  //   graphicLayer.eachGraphic((graphic, index) => {
  //       console.log(index);
  //       console.log(graphic);
  //       graphic.options.style.label.text = i;
  //       graphic._entity._label._text._value = i + "";
  //     i+=1
  //   });
  // }, 500);
}
// 绑定右键菜单
export function bindLayerContextMenu() {
  graphicLayer.bindContextMenu([
    {
      text: "删除对象",
      icon: "fa fa-trash-o",
      show: (event) => {
        const graphic = event.graphic;
        if (!graphic || graphic.isDestroy) {
          return false;
        } else {
          return true;
        }
      },
      callback: (e) => {
        const graphic = e.graphic;
        if (!graphic) {
          return;
        }
        const parent = graphic.parent; // 右击是编辑点时
        graphicLayer.removeGraphic(graphic);
        let { _lng } = mars3d.LngLatPoint.fromCartesian(graphic._position_draw);

        // positions.forEach((el) => {
        //   if (_lng == el[0]) {
        //   }
        // });
        var i = positions.length;
        while (i--) {
          if (positions[i][0] == _lng) {
            positions.splice(i, 1);
          }
        }
        let ind = 0;
        graphicLayer.eachGraphic((graphic) => {
          console.log(graphic, "graphic");
          var i = (ind += 1);
          graphic.options.style.label.text = i;
          graphic._entity._label._text._value = i + "";
        });
        index -= 1;
        startDrawGraphic();
        if (parent) {
          graphicLayer.removeGraphic(parent);
        }
      },
    },
  ]);
}

export function setCameraView() {
  // Vue.$GLOBAL.map.flyToPoint([positions[0][0], positions[0][1], 100]);
  stopDrawShow = true;
  graphicLayer.stopDraw();

  let arr = [];
  graphicLayer.eachGraphic((graphic) => {
    console.log(graphic, "graphic");
    let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
      graphic._position_draw
    );
    // arr.push(graphic);
    arr.push([_lng, _lat, _alt]);
  });
  setTimeout(() => {
    // Vue.$GLOBAL.map.flyToGraphic(arr[0], { radius: 100 });
    Vue.$GLOBAL.map.flyToPositions(arr);
  }, 100);
}

export function deleteAll() {
  console.log("删除所有");
  if (graphicLayer) graphicLayer.clear();
  positions = [];
  index = 1;
}
export function stopDrawShowFun() {
  stopDrawShow = false;
}
